export function formatCurrency(
  amountCents: number,
  locale: string,
  currency?: string,
): string {
  return Intl.NumberFormat(locale, {
    style: 'currency',
    currencyDisplay: 'narrowSymbol',
    currency: currency?.toUpperCase() || 'USD',
    minimumFractionDigits: 2,
  }).format(amountCents / 100);
}
